import ReactSelect from 'react-select';
import React from 'react';
import { theme } from '../../styles/theme';

export const SelectStyle = {
  container: styles => ({ ...styles, flex: 1 }),
  control: (styles, { isSelected, isFocused }) => ({
    ...styles,
    borderColor:
      isSelected || isFocused ? theme.primaryColor : 'rgb(204, 204, 204)',
    boxShadow:
      isSelected || isFocused ? `0 0 0 1px ${theme.primaryColor}` : null,
    ':hover': {
      ...styles[':hover'],
      borderColor:
        isSelected || isFocused ? theme.primaryColor : theme.terminalBg,
    },
  }),
};

export class Select extends ReactSelect {
  render() {
    return <ReactSelect styles={SelectStyle} {...this.props} />;
  }
}
